import { AddressObjectType } from './types'
import { useFormContext } from 'react-hook-form'
import { FormTextField } from 'ComponentLibrary/src/atoms/forms'

type AddressInputProps = {
    disabled?: boolean
    hiddenFields?: Partial<Readonly<Record<keyof AddressObjectType, boolean>>>
    nestedAddress?: boolean
    labels?: Partial<AddressInputLabels>
}

export type AddressInputLabels = typeof userText

/**
 * Address input component for use with react hook form.
 * Must be wrapped inside a FormProvider
 */
export const AddressInput = ({ hiddenFields, disabled = false, labels }: AddressInputProps) => {
    const resolvedLabels = { ...userText, ...labels }
    const {
        control,
        formState: { errors },
    } = useFormContext<AddressObjectType>()

    return (
        <>
            {!hiddenFields?.street && (
                <FormTextField
                    fieldName={'street'}
                    control={control}
                    label={resolvedLabels.street}
                    required
                    errors={errors}
                    disabled={disabled}
                    xs={8}
                />
            )}
            {!hiddenFields?.house_number && (
                <FormTextField
                    label={resolvedLabels.house_number}
                    errors={errors}
                    disabled={disabled}
                    control={control}
                    fieldName={'house_number'}
                    xs={4}
                />
            )}
            {!hiddenFields?.zip && (
                <FormTextField
                    disabled={disabled}
                    errors={errors}
                    label={resolvedLabels.zip}
                    required
                    control={control}
                    fieldName={'zip'}
                    xs={4}
                />
            )}
            {!hiddenFields?.city && (
                <FormTextField
                    errors={errors}
                    label={resolvedLabels.city}
                    required
                    disabled={disabled}
                    control={control}
                    fieldName={'city'}
                    xs={8}
                />
            )}
            {!hiddenFields?.state && (
                <FormTextField
                    control={control}
                    fieldName={'state'}
                    label={resolvedLabels.state}
                    errors={errors}
                    disabled={disabled}
                    xs={6}
                />
            )}
            {!hiddenFields?.country && (
                <FormTextField
                    disabled={disabled}
                    errors={errors}
                    label={resolvedLabels.country}
                    required
                    control={control}
                    fieldName="country"
                    xs={6}
                />
            )}
        </>
    )
}

export const userText = {
    street: 'Straße',
    house_number: 'Hausnummer',
    state: 'Bundesland',
    city: 'Stadt',
    zip: 'PLZ',
    country: 'Land',
}

export default AddressInput
